// removed by extract-text-webpack-plugin
module.exports = {"root":"_2Yewm","timeline":"uRNtr","event":"_34yuA"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/Events/pages/Index.sass
// module id = ./src/modules/Events/pages/Index.sass
// module chunks = 6